<template>
  <div v-if="dataReady">
    <Dashboard :learn-paths="learnPaths" />
  </div>
  <div v-else>
    <ContentSpinner />
  </div>
</template>

<script>
import * as R from 'ramda'
import Dashboard from '../components/Dashboard'
import ContentSpinner from '../components/ui/ContentSpinner'
import dashboardGql from './dashboard.gql'

export default {
  components: {
    ContentSpinner,
    Dashboard,
  },

  apollo: {
    learnPaths: {
      result({ data, loading, networkStatus }) {
        this.dataReady = true
      },
      query: dashboardGql,
      update(data) {
        return R.pathOr([], ['learnPaths', 'edges'], data)
      },
    },
  },

  data() {
    return {
      dataReady: false,
    }
  },
}
</script>
